<template>
	<article class="still">
		<router-link
			v-for="project in projects"
			class="still__box"
			:to="`/still/${projectUrl(project.name)}`"
			tag="div"
			:key="project.id"
		>
			<img :src="$getImgUrl(getName(project.mainImageId))" :alt="project.name" />
			<div class="still__overlay"></div>
			<p class="title">{{ project.name }}</p>
		</router-link>
		<div class="still__last"></div>
	</article>
</template>
<script>
export default {
	created() {
		if (!this.$store.getters['project/data'].length) {
			this.$router.push('/404')
		}
	},
	computed: {
		projects: ({ $store }) =>
			$store.getters['project/data'].filter((item) => item.mainImageId)
	},
	methods: {
		getName(id) {
			const index = this.$store.getters['image/data'].findIndex(
				(i) => i.id === +id
			)
			return this.$store.getters['image/data'][index].name
		},
		projectUrl(name) {
			return name
				.split(' ')
				.join('-')
				.toLowerCase()
		}
	}
}
</script>
